import { Tabs as MantineTabs, useMantineTheme } from "@mantine/core"
import {
  IconBellRinging,
  IconClipboardData,
  IconInfoCircle,
  IconMovie,
  IconQuestionCircle,
} from "@tabler/icons"
import { useTranslation } from "react-i18next"
import { useLocation, useNavigate } from "react-router-dom"
import Props from "./Tabs.types"

const TAB_MAX_WIDTH = 160

const Tabs = ({ mobile }: Props) => {
  const { pathname } = useLocation()
  const navigate = useNavigate()
  const { t } = useTranslation()
  const {
    colors: { gray },
  } = useMantineTheme()

  const tabs = [
    <MantineTabs.Tab key="stats-tab" value="/" icon={<IconClipboardData />}>
      {mobile ? "" : (t`Statistiche` as string)}
    </MantineTabs.Tab>,
    <MantineTabs.Tab key="info-tab" value="/info" icon={<IconInfoCircle />}>
      {mobile ? "" : (t`Informazioni` as string)}
    </MantineTabs.Tab>,
    <MantineTabs.Tab key="faqs-tab" value="/faqs" icon={<IconQuestionCircle />}>
      {mobile ? "" : (t`FAQ` as string)}
    </MantineTabs.Tab>,
    <MantineTabs.Tab key="videos-tab" value="/videos" icon={<IconMovie />}>
      {mobile ? "" : (t`Video` as string)}
    </MantineTabs.Tab>,
    <MantineTabs.Tab
      key="notifications-tab"
      value="/notifications"
      icon={<IconBellRinging />}
    >
      {mobile ? "" : (t`Notifiche` as string)}
    </MantineTabs.Tab>,
  ]

  return (
    <MantineTabs
      radius="xs"
      defaultValue="/"
      styles={{
        root: {
          height: "100%",
          width: "100%",
        },
        tabsList: { height: "100%", justifyContent: "center" },
        tab: {
          ":hover": {
            backgroundColor: "transparent",
          },
          width: `calc(100% / ${tabs.length})`,
          ...(mobile
            ? {
                borderBottom: "none",
                borderTop: "2px solid " + gray[2],
                margin: 0,
              }
            : { maxWidth: TAB_MAX_WIDTH + "px" }),
        },
      }}
      value={pathname}
      onTabChange={(value) => navigate(value as string)}
    >
      <MantineTabs.List style={{ border: "none" }}>{tabs}</MantineTabs.List>
    </MantineTabs>
  )
}

export default Tabs
